import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} KOTTO. All rights reserved.</p>
                <div className="social-links-footer">
                    <a href="https://www.instagram.com/kotto_music?igsh=MWxyZm9xbnN0NXpyYw==" target="_blank" rel="noreferrer">Instagram</a>
                    <a href="https://www.tiktok.com/@iamkotto?_r=1&_t=ZN-93q1sDkwZ8g" target="_blank" rel="noreferrer">TikTok</a>
                    <a href="https://on.soundcloud.com/sZQ8llb5tpfRllKaJa" target="_blank" rel="noreferrer">SoundCloud</a>
                    <a href="https://open.spotify.com/artist/2ejaEi059MeOevfNHRO6Ot?si=abV1sCF0TlCjKWLVFO9BHA" target="_blank" rel="noreferrer">Spotify</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
